/** Pure rules for where CDN playback cookies work. No DOM access, testable. */

/** Cookie path = playlist folder. Each clip keeps its own cookie; several players per page coexist. */
export function cdnCookiePath(playlistUrl: string): string {
  const path = new URL(playlistUrl).pathname;
  return path.slice(0, path.lastIndexOf("/") + 1);
}

/**
 * New URL per mint: same URL after cookie refresh never reloads the player. Cache ignores the query.
 */
export function playlistUrlForMint(
  playlistUrl: string,
  expiresAtMs: number,
): string {
  const url = new URL(playlistUrl);
  url.searchParams.set("v", String(expiresAtMs));
  return url.toString();
}

export function isHostUnderCookieDomain(
  host: string,
  cookieDomain: string,
): boolean {
  const base = cookieDomain.replace(/^\./, "").toLowerCase();
  const h = host.toLowerCase();
  return h === base || h.endsWith(`.${base}`);
}

/**
 * Browser sends the cookies only if page and every embedding page share the site.
 * Foreign-site embed → false → MP4.
 */
export function canUseCdnCookies(
  cookieDomain: string,
  pageHost: string,
  ancestorHosts: readonly string[],
): boolean {
  return [pageHost, ...ancestorHosts].every((host) =>
    isHostUnderCookieDomain(host, cookieDomain),
  );
}
